/**
 * gets label or default fallback
 * @param  {string} options.label
 * @return {string}
 */
export const getLabel = ({ label }) => {
  if (label) return label;

  return 'Select Date';
};
